import React, { useMemo, useState, createContext, useContext } from 'react';
import { ThemeProvider, createTheme, PaletteMode } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

interface ThemeContextProps {
    mode: PaletteMode;
    toggleTheme: () => void;
}

const ThemeToggleContext = createContext<ThemeContextProps>({
    mode: 'light',
    toggleTheme: () => {},
});

export const useThemeToggle = () => useContext(ThemeToggleContext);

const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [mode, setMode] = useState<PaletteMode>('dark');

    const toggleTheme = () => {
        setMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'));
    };

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                },
            }),
        [mode]
    );

    return (
        <ThemeToggleContext.Provider value={{ mode, toggleTheme }}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ThemeToggleContext.Provider>
    );
};

export default ThemeProviderWrapper;
